import React, { useEffect, useState } from "react";
import NavigationButtons from "./components/NavigationButtons";
import CategoryCarousel from "./components/CategoryCarousel";
import { jobCategories } from "./components/data";
import { Divider } from "antd";

import JobService from '@/services/JobService'

const SectionJobCategories = () => {
  const [majors, setMajors] = useState([])

  useEffect(() => {
    JobService.getMajorList().then(res => {
      setMajors(res)
    })
  }, [])

    return (
    <section className="p-4 ">
      <div className="flex flex-col md:flex-row gap-4 justify-between items-center mb-3">
        <Divider
          className="font-bold uppercase w-full"
          style={{ borderColor: "#7cb305" }}
          align="center"
          orientation="center"
        >
          <h1 className="lg:text-3xl text-md font-bold text-green-700">
            Việc làm theo ngành nghề nổi bật
          </h1>
          <p className="lg:text-sm text-xs text-gray-500">
            Những ngành nghề được lựa chọn nhiều nhất.
          </p>
        </Divider>
      </div>
      <CategoryCarousel
        categories={majors}
        nextID="prevJobCategories"
        prevID="nextJobCategories"
      />
      <div className="flex justify-center mt-4">
        <NavigationButtons
          nextID="prevJobCategories"
          prevID="nextJobCategories"
        />
      </div>
    </section>
  );
};

export default SectionJobCategories;
